(ns minorodata.connections.sources.google-analytics
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::bearer-token
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Auth token can't be empty"})))


(spec/def ::google-analytics-form
  (spec/and
    (spec/keys :req-un [::name ::bearer-token]
               :opt-un [::description])))


(def source
  {:id           "google-analytics"
   :enabled      false
   :name         "Google Analytics"
   :image-source "google-analytics.png"
   :description  "Free tools you need to analyze data for your business in one place"
   :tags         ["analytics"]

   :preview-formatter
   ;; Formatter for oauth
   ;; (fn [] "Authenticated by token")

   (fn [source]
     (str "Client: "
          (get-in source [:credentials :client-email])
          ", project: "
          (get-in source [:credentials :project-id])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description client-email client-id private-key private-key-id project-id]} data]
        {:source-type "google-analytics"
         :name        name
         :description description

         :source
         {:credentials {:type           "service_account"
                        :client_email   client-email
                        :client_id      client-id
                        :private_key    private-key
                        :private_key_id private-key-id
                        :project_id     project-id}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:client-email :client-id :private-key :private-key-id :project-id]))))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    ;; Validation for oauth form
    ;; :validate (partial form-component/validate-form ::google-analytics-form)

    :validate (constantly nil)

    :id :google-analytics-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "Client Email"
              :name       :client-email
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Client ID"
              :name       :client-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key"
              :name       :private-key
              :type       :password
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key ID"
              :name       :private-key-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Project ID"
              :name       :project-id
              :required   true
              :value      ""}

             ;; Disabling oauth until we get the app approved
             ;;

             ;; {:block-type :oauth
             ;;  :label      "Google Analytics Login"
             ;;  :name       :bearer-token
             ;;  :required   true
             ;;
             ;;  ;; https://developers.google.com/identity/protocols/oauth2/web-server#httprest
             ;;  :request-uri      "https://accounts.google.com/o/oauth2/v2/auth"
             ;;  :params-processor (fn [{:keys [client-id redirect-uri state scope response-type]}]
             ;;                      {:response_type response-type
             ;;                       :scope         scope
             ;;                       :client_id     client-id
             ;;                       :redirect_uri  redirect-uri
             ;;                       :state         state})
             ;;
             ;;  :response-processor (fn [response] (:code response))
             ;;
             ;;  :response-type "code"
             ;;  :client-id     "12540259386-c3pv0q0k5dq0ie258jsjktsmarj5d1oj.apps.googleusercontent.com"
             ;;  ;; https://developers.google.com/identity/protocols/oauth2/scopes#analyticsreporting
             ;;  :scope         "https://www.googleapis.com/auth/analytics.readonly"
             ;;  }

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table
                 report view-id sampling-level]}]
      {:name          name
       :description   (or description "")
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :destination-table destination-table
                    :report            report
                    :view-id           view-id
                    :sampling-level    sampling-level}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:action :destination-table :report :view-id :sampling-level])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :google-analytics-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Standard Report" :value "standard"}
                           {:name "Channel Report"  :value "channel"}]
              :required   true
              :value      "standard"}

             {:content [:p
                        "Metrics: Sessions, New Users, Users, Bounces, Transactions, Revenue."
                        [:br]
                        "Dimensions: Date, Device Category."]
              :conditions [[:eq [:report :value] "standard"]]}

             {:content [:p
                        "Metrics: Sessions, New Users, Users, Bounces, Transactions, Revenue."
                        [:br]
                        "Dimensions: Date, Device Category, Source, Medium, Campaign, Keyword, Ad Content, Landing Page."]
              :conditions [[:eq [:report :value] "channel"]]}

             {:block-type :input
              :label      "View ID"
              :required   true
              :name       :view-id
              :type       :number}

             {:block-type :select
              :label      "Sampling level"
              :name       :sampling-level
              :options    [{:name "Default" :value "default"}
                           {:name "Small"   :value "small"}
                           {:name "Large"   :value "large"}]
              :required   true
              :value      "default"}

             {:content "DEFAULT - Returns a sample size that balances speed and accuracy."
              :conditions [[:eq [:sampling-level :value] "default"]]}

             {:content "SMALL - Returns a fast response with a smaller sampling size."
              :conditions [[:eq [:sampling-level :value] "small"]]}

             {:content "LARGE - Returns more accurate data using a large sampling size. But this may result in the extract being slower."
              :conditions [[:eq [:sampling-level :value] "large"]]}


             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
